var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1711,
    height: 318,
    viewBox: "0 0 1711 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.208 259.467C600.793 259.467 627.989 237.454 627.989 203.755C628.261 174.682 610.786 157.826 581.637 147.231L561.651 139.893C541.394 132.556 531.674 126.307 531.674 112.177C531.674 98.0457 546.106 89.8965 562.765 89.8965C578.31 89.8965 590.244 96.1446 600.237 107.83L622.72 86.3607C608.288 69.239 587.474 60 563.049 60C526.405 60 498.938 80.6575 498.938 114.356C498.938 140.717 514.199 157.56 545.562 168.712L567.217 176.317C586.089 183.11 595.253 191.804 595.253 205.668C595.253 220.065 581.934 229.583 563.333 229.583C544.177 229.583 527.803 220.344 517.538 204.857L492 224.691C503.637 245.603 530.561 259.467 562.208 259.467ZM716.376 258.922C745.526 258.922 767.168 246.959 779.659 227.403L756.347 211.093C748.852 223.056 736.362 231.75 716.661 231.75C693.349 231.75 675.305 217.353 673.92 194.794H782.998C783.27 190.447 783.27 188.001 783.27 185.011C783.27 141.262 753.02 117.613 716.376 117.613C674.192 117.613 643.93 148.321 643.93 188.268C643.93 229.837 674.18 258.922 716.376 258.922ZM675.293 173.047C679.733 152.935 697.22 142.884 715.263 142.884C733.022 142.884 749.124 153.479 752.451 173.047H675.293ZM941.878 313V120.326H911.344V138.537C903.577 127.664 886.919 117.613 866.933 117.613C828.904 117.613 800.04 149.411 800.04 188.268C800.04 227.125 828.904 258.922 866.933 258.922C886.919 258.922 903.577 248.872 911.344 237.998V313H941.878ZM872.486 231.738C848.061 231.738 831.131 212.715 831.131 188.256C831.131 163.796 848.061 144.773 872.486 144.773C896.911 144.773 913.842 163.796 913.842 188.256C913.842 212.715 896.911 231.738 872.486 231.738ZM1020.88 258.922C1038.64 258.922 1053.35 251.584 1061.41 237.72V256.198H1091.94V120.326H1061.41V187.178C1061.41 216.53 1047.53 231.75 1027.54 231.75C1009.79 231.75 999.793 218.431 999.793 196.696V120.326H969.259V201.587C969.259 236.364 988.959 258.922 1020.88 258.922ZM1187.43 258.922C1216.58 258.922 1238.22 246.959 1250.71 227.403L1227.4 211.093C1219.9 223.056 1207.41 231.75 1187.71 231.75C1164.4 231.75 1146.36 217.353 1144.97 194.794H1254.05C1254.32 190.447 1254.32 188.001 1254.32 185.011C1254.32 141.262 1224.07 117.613 1187.43 117.613C1145.24 117.613 1114.98 148.321 1114.98 188.268C1114.98 229.837 1145.23 258.922 1187.43 258.922ZM1146.34 173.047C1150.78 152.935 1168.27 142.884 1186.31 142.884C1204.07 142.884 1220.17 153.479 1223.5 173.047H1146.34ZM1277.37 256.198H1307.91V189.346C1307.91 159.994 1323.45 144.773 1343.71 144.773C1361.47 144.773 1372.57 157.548 1372.57 179.283V256.186H1403.11V174.391C1403.11 139.881 1382.29 117.589 1350.09 117.589C1332.05 117.589 1316.5 124.927 1307.91 138.792V120.326H1277.37V256.198ZM1497.12 258.922C1525.99 258.922 1549.86 244.247 1561.79 221.422L1535.14 207.291C1528.47 221.155 1514.88 231.205 1497.11 231.205C1472.41 231.205 1454.93 212.449 1454.93 188.268C1454.93 164.087 1472.41 145.33 1497.11 145.33C1514.87 145.33 1528.47 155.381 1535.14 169.245L1561.79 155.114C1549.86 132.289 1525.99 117.613 1497.12 117.613C1455.5 117.613 1423.85 148.055 1423.85 188.268C1423.85 228.481 1455.5 258.922 1497.12 258.922ZM1644.11 258.922C1673.26 258.922 1694.9 246.959 1707.39 227.403L1684.08 211.093C1676.58 223.056 1664.09 231.75 1644.39 231.75C1621.07 231.75 1603.04 217.353 1601.64 194.794H1710.73C1711 190.447 1711 188.001 1711 185.011C1711 141.262 1680.75 117.613 1644.11 117.613C1601.91 117.613 1571.66 148.321 1571.66 188.268C1571.66 229.837 1601.91 258.922 1644.11 258.922ZM1603.02 173.047C1607.46 152.935 1624.95 142.884 1642.99 142.884C1660.75 142.884 1676.85 153.479 1680.18 173.047H1603.02Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 67.505L0 250.165C0 287.447 30.1402 317.67 67.32 317.67H328.68C365.86 317.67 396 287.447 396 250.165V67.505C396 30.2231 365.86 9.15527e-05 328.68 9.15527e-05H67.32C30.1402 9.15527e-05 0 30.2231 0 67.505Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 67.505L0 250.165C0 287.447 30.1402 317.67 67.32 317.67H328.68C365.86 317.67 396 287.447 396 250.165V67.505C396 30.2231 365.86 9.15527e-05 328.68 9.15527e-05H67.32C30.1402 9.15527e-05 0 30.2231 0 67.505Z",
    fill: "url(#paint0_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 79.4176C98.9999 68.4523 90.1351 59.5632 79.1999 59.5632C68.2647 59.5632 59.3999 68.4523 59.3999 79.4176C59.3999 90.3829 68.2647 99.272 79.1999 99.272C90.1351 99.272 98.9999 90.3829 98.9999 79.4176Z",
    fill: "url(#paint1_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 79.4176C98.9999 68.4523 90.1351 59.5632 79.1999 59.5632C68.2647 59.5632 59.3999 68.4523 59.3999 79.4176C59.3999 90.3829 68.2647 99.272 79.1999 99.272C90.1351 99.272 98.9999 90.3829 98.9999 79.4176Z",
    fill: "url(#paint2_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 79.4176C98.9999 68.4523 90.1351 59.5632 79.1999 59.5632C68.2647 59.5632 59.3999 68.4523 59.3999 79.4176C59.3999 90.3829 68.2647 99.272 79.1999 99.272C90.1351 99.272 98.9999 90.3829 98.9999 79.4176Z",
    fill: "url(#paint3_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9999 238.126C98.9999 227.161 90.1351 218.272 79.1999 218.272C68.2647 218.272 59.3999 227.161 59.3999 238.126C59.3999 249.092 68.2647 257.981 79.1999 257.981C90.1351 257.981 98.9999 249.092 98.9999 238.126Z",
    fill: "url(#paint4_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6 158.835C336.6 147.87 327.735 138.981 316.8 138.981C305.865 138.981 297 147.87 297 158.835C297 169.8 305.865 178.69 316.8 178.69C327.735 178.69 336.6 169.8 336.6 158.835Z",
    fill: "url(#paint5_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6 158.835C336.6 147.87 327.735 138.981 316.8 138.981C305.865 138.981 297 147.87 297 158.835C297 169.8 305.865 178.69 316.8 178.69C327.735 178.69 336.6 169.8 336.6 158.835Z",
    fill: "url(#paint6_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 59.5632H158.4C147.465 59.5632 138.6 68.4523 138.6 79.4176C138.6 90.3829 147.465 99.272 158.4 99.272H316.8C327.735 99.272 336.6 90.3829 336.6 79.4176C336.6 68.4523 327.735 59.5632 316.8 59.5632Z",
    fill: "url(#paint7_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 218.272H158.4C147.465 218.272 138.6 227.161 138.6 238.126C138.6 249.092 147.465 257.981 158.4 257.981H316.8C327.735 257.981 336.6 249.092 336.6 238.126C336.6 227.161 327.735 218.272 316.8 218.272Z",
    fill: "url(#paint8_linear_24_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6 138.981H79.2C68.2648 138.981 59.4 147.87 59.4 158.835C59.4 169.8 68.2648 178.69 79.2 178.69H237.6C248.535 178.69 257.4 169.8 257.4 158.835C257.4 147.87 248.535 138.981 237.6 138.981Z",
    fill: "url(#paint9_linear_24_285)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_285",
    x1: 198,
    y1: 0.000132138,
    x2: 198,
    y2: 318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D273D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0F13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_285",
    x1: 65.5,
    y1: 99.0001,
    x2: 92.5,
    y2: 63.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D69FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_285",
    x1: 62.8799,
    y1: 99.2913,
    x2: 96.1377,
    y2: 97.5912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3757FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24_285",
    x1: 62.8799,
    y1: 99.2913,
    x2: 96.1377,
    y2: 97.5912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24_285",
    x1: 65,
    y1: 251.5,
    x2: 91.5,
    y2: 223.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D972F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24_285",
    x1: 305,
    y1: 172,
    x2: 329.5,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E7FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24_285",
    x1: 300.18,
    y1: 178.418,
    x2: 334.567,
    y2: 176.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_24_285",
    x1: 154.5,
    y1: 99.0001,
    x2: 317.5,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_24_285",
    x1: 156,
    y1: 258,
    x2: 312.5,
    y2: 218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_24_285",
    x1: 86.0001,
    y1: 179,
    x2: 235.5,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6634FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C6DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 317.67,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7c9fc677fe69678a0a3dea6090ba6e9.svg";
export { ForwardRef as ReactComponent };